import { render, staticRenderFns } from "./ProjectsModal.vue?vue&type=template&id=0dac38bb"
import script from "./ProjectsModal.vue?vue&type=script&lang=js"
export * from "./ProjectsModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectsModal.vue?vue&type=style&index=0&id=0dac38bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports